import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  success: null,
};

const digitalTwinSlice = createSlice({
  name: "digitalTwin",
  initialState,
  reducers: {
    fetchDigitalTwinStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    fetchDigitalTwinSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchDigitalTwinFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
  },
});

export const { fetchDigitalTwinStart, fetchDigitalTwinSuccess, fetchDigitalTwinFailure } =
  digitalTwinSlice.actions;
export default digitalTwinSlice.reducer;
